import React, { useEffect, useState } from "react";
import $, { param } from "jquery";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import { format } from "date-fns";
import ReferenceForm from "../../components/Modals/Candidate/Candidaterefform";
import { openInAppTab } from "../../utils/tabNavigation";
import useSmartBack from "../../hooks/useSmartBack";

function Candidaterefs() {
  const { id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const REACT_APP_BASE_URL_BACK = process.env.REACT_APP_BASE_URL_BACK;
  const [data, setData] = useState([]);
  const { setGlobalLoading, token } = useOutletContext();
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [CandidaterefModal, setCandidaterefModal] = useState(false);
  const [imageUrl,setImageUrl] = useState("")
  const handleBack = useSmartBack(`/candidates/view/${id}`);

  useEffect(() => {
    async function fetchOptions() {
      setGlobalLoading(true); //  Show loader before API call
      try {
        const response = await axios.get(
          `${API_BASE_URL}/candidates/get_candidates_references/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data);
        setData(response.data.ref_list[0].data || []);
      } catch (error) {
        console.error("API Error:", error);
        setData([]); // Prevent errors from breaking UI
      } finally {
        setGlobalLoading(false); // ✅ Hide loader after API call
      }
    }
    fetchOptions();
  }, [id]);

  const parseSafeDate = (str) => {
  if (!str || str.trim() === "" || str.trim().toLowerCase() === "present") {
    return null;
  }

  // Try native date format (ISO)
  const direct = new Date(str);
  if (!isNaN(direct.getTime())) {
    return direct;
  }

  // Try D-M-Y or D/M/Y or D.M.Y formats
  const match = str.match(/^(\d{1,2})[-\/\.](\d{1,2})[-\/\.](\d{4})$/);
  if (match) {
    const [_, d, m, y] = match;
    const parsed = new Date(`${y}-${m}-${d}`);
    return !isNaN(parsed.getTime()) ? parsed : null;
  }

  return null;
  };

  const Dp = async (filename) => {
    const response = await fetch(
        `${REACT_APP_BASE_URL_BACK}files/candidates/picture/${filename}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      setImageUrl(url);
  }
  
   useEffect(() => {
      if (!data?.userpic) return;
      console.log("img", data.candidate_pic)
        Dp(data?.candidate_pic)
    }, [data]);

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Possible Referee List</h2>
          </div>
           <button
              className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center"
              style={{
                cursor: "pointer",
                float: "right",
                position: "relative",
               
              }}
              onClick={handleBack}
            >
              <i className="ti ti-arrow-left me-2"></i>
              Back
            </button>
        </div>

        <div className="row">
          {data.length > 0
            ? data.map((data, index) => (
                <div className="col-xl-3 col-lg-4 col-md-6">
                  <div className="card" style={{ minHeight: "300px" }}>
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div className="form-check form-check-md"></div>
                        <div>
                          <a
                            href={`/candidates/view/${data.candidate_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(event) => {
                              event.preventDefault();
                              openInAppTab(
                                `/candidates/view/${data.candidate_id}`,
                              );
                            }}
                            className="avatar avatar-xl avatar-rounded online border p-1 border-primary rounded-circle"
                          >
                            <img
                              src={imageUrl}
                              className="img-fluid h-auto w-auto"
                              alt="Img"
                            />
                          </a>
                        </div>
                        <div className="dropdown">
                          <a
                            href="javascript:void(0)"
                            onClick={(e) => {
                              setCandidaterefModal(true);
                              setSelectedCandidateId(data?.candidate_id);
                            }}
                            title="Add Comments"
                          >
                            <i className="fa-solid fa-edit"></i>
                          </a>
                        </div>
                      </div>
                      <div className="text-center mb-3">
                        <h6 className="mb-1">
                          <a
                            href={`/candidates/view/${data.candidate_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(event) => {
                              event.preventDefault();
                              openInAppTab(
                                `/candidates/view/${data.candidate_id}`,
                              );
                            }}
                          >
                            {data.candidate_name}
                          </a>
                        </h6>
                        <span
                          style={{
                            whiteSpace: "break-spaces",
                            lineHeight: "1.9",
                          }}
                          className="badge bg-pink-transparent fs-10 fw-medium"
                        >
                          {data.designation}
                        </span>
                      </div>
                      <div className="d-flex flex-column">
                        <p className="text-dark d-inline-flex align-items-center mb-2">
                          <i className="ti ti-smart-home text-gray-5 me-2"></i>
                          {data.company}
                        </p>
                        <p className="text-dark d-inline-flex align-items-center">
                          <i className="ti ti-map-pin text-gray-5 me-2"></i>
                          {data.location}
                        </p>
                        <p className="text-dark d-inline-flex align-items-center mb-2">
                          <i className="ti ti-timeline text-gray-5 me-2"></i>
                          {data.start_date} -{" "}
                         {parseSafeDate(data.end_date) ? format(parseSafeDate(data.end_date), "dd MMM yyyy") : "Present"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : ""}
          {CandidaterefModal && (
            <ReferenceForm
              onclose={() => setCandidaterefModal(false)}
              refcandidateid={selectedCandidateId}
              candidate_id={id}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Candidaterefs;
